var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{ref:"element",attrs:{"value":_vm.fieldStringValue,"readonly":_vm.readonly,"placeholder":_vm.placeholder},on:{"blur":_vm.blur,"update":_vm.onFieldStringValueChange}})}
var staticRenderFns = []

export { render, staticRenderFns }